
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";
import FormGroup from "@/components/form/FormGroupNew.vue";
import FormInputGroup from "@/components/form/FormInputGroupNew.vue";
import FormDatepicker from "@/components/form/FormDatepickerNew.vue";
import LocationModal from "@/views/clients/LocationModal.vue";
import FormSelect from "@/components/form/FormSelectNew.vue";
import _ from "lodash";
import moment from "moment";

@Component({
  components: {
    ValidationProvider,
    LocationModal,
    FormGroup,
    FormInputGroup,
    FormDatepicker,
    FormSelect,
  },
})
export default class ClientInformation extends Vue {
  @Prop({ required: true }) readonly formData!: Record<string, any>;
  localFormData: Record<string, any> = {};

  @Watch("formData", { immediate: true, deep: true })
  onFormDataChange(newVal: Record<string, any>) {
    this.localFormData = _.cloneDeep(newVal);
  }

mounted(){
// if (this.localFormData.dob) {
//   console.log("localFormData.dob", this.localFormData.dob);
//    this.localFormData.dob = moment(this.localFormData.dob, "YYYY-MM-DD").toDate();
//   }
 this.$nextTick(() => {
        (this.$refs.startDateValidator as any).validate();
        (this.$refs.endDateValidator as any).validate();
    });

}
  updateField(field: string, value: any) {
    this.localFormData[field] = value;
    this.$emit("update:formData", this.localFormData);
  }
  // updateField(field: string, value: any, isDate: boolean = false) {
  //   if (isDate) {
  //     this.localFormData[field] = moment(value);
  //   } else {
  //     this.localFormData[field] = value;
  //   }
  //   this.$emit("update:formData", this.localFormData);
  // }
}
